var _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeachingCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 60,
    viewBox: "0 0 36 56",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 6A3.5 3.5 0 014 2.5h28A3.5 3.5 0 0135.5 6v36a3.5 3.5 0 01-3.5 3.5H4A3.5 3.5 0 01.5 42zm20 48.523V45.5h9v9.023a.5.5 0 01-.686.464l-3.628-1.451L25 53.46l-.186.075-3.628 1.451a.5.5 0 01-.686-.464z",
    stroke: "#50b3ec"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 44,
    fill: "#fff",
    r: 6.5,
    stroke: "#50b3ec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3420ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5h15v8.586a.97.97 0 01-.44.812 12.93 12.93 0 01-14.12 0 .97.97 0 01-.44-.812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.76 7.719a4 4 0 00-2.519 0l-8.694 2.883c-1.827.606-1.827 3.19 0 3.796l8.694 2.883a4 4 0 002.518 0l8.694-2.883c1.827-.606 1.827-3.19 0-3.796z",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.644a.6.6 0 01.064-.273 1.58 1.58 0 011.41-.871H10v5a1 1 0 11-2 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    rx: 0.5,
    width: 18,
    x: 9,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    rx: 0.5,
    width: 18,
    x: 9,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    rx: 0.5,
    width: 12,
    x: 9,
    y: 35
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMzYgNTYiIHdpZHRoPSI2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtLjUgNmEzLjUgMy41IDAgMCAxIDMuNS0zLjVoMjhhMy41IDMuNSAwIDAgMSAzLjUgMy41djM2YTMuNSAzLjUgMCAwIDEgLTMuNSAzLjVoLTI4YTMuNSAzLjUgMCAwIDEgLTMuNS0zLjV6bTIwIDQ4LjUyM3YtOS4wMjNoOXY5LjAyM2EuNS41IDAgMCAxIC0uNjg2LjQ2NGwtMy42MjgtMS40NTEtLjE4Ni0uMDc2LS4xODYuMDc1LTMuNjI4IDEuNDUxYS41LjUgMCAwIDEgLS42ODYtLjQ2NHoiIHN0cm9rZT0iIzUwYjNlYyIvPjxjaXJjbGUgY3g9IjI1IiBjeT0iNDQiIGZpbGw9IiNmZmYiIHI9IjYuNSIgc3Ryb2tlPSIjNTBiM2VjIi8+PGcgZmlsbD0iIzM0MjBlZCI+PHBhdGggZD0ibTExIDE0LjVoMTV2OC41ODZhLjk3Ljk3IDAgMCAxIC0uNDQuODEyIDEyLjkzIDEyLjkzIDAgMCAxIC0xNC4xMiAwIC45Ny45NyAwIDAgMSAtLjQ0LS44MTJ6Ii8+PHBhdGggZD0ibTE5Ljc2IDcuNzE5YTQgNCAwIDAgMCAtMi41MTkgMGwtOC42OTQgMi44ODNjLTEuODI3LjYwNi0xLjgyNyAzLjE5IDAgMy43OTZsOC42OTQgMi44ODNhNCA0IDAgMCAwIDIuNTE4IDBsOC42OTQtMi44ODNjMS44MjctLjYwNiAxLjgyNy0zLjE5IDAtMy43OTZ6IiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIvPjxwYXRoIGQ9Im04IDEyLjY0NGEuNi42IDAgMCAxIC4wNjQtLjI3MyAxLjU4IDEuNTggMCAwIDEgMS40MS0uODcxaC41MjZ2NWExIDEgMCAxIDEgLTIgMHoiLz48cmVjdCBoZWlnaHQ9IjEiIHJ4PSIuNSIgd2lkdGg9IjE4IiB4PSI5IiB5PSIyOSIvPjxyZWN0IGhlaWdodD0iMSIgcng9Ii41IiB3aWR0aD0iMTgiIHg9IjkiIHk9IjMyIi8+PHJlY3QgaGVpZ2h0PSIxIiByeD0iLjUiIHdpZHRoPSIxMiIgeD0iOSIgeT0iMzUiLz48L2c+PC9zdmc+";
export { SvgTeachingCertificate as ReactComponent };